<template>
    <div>
        <!-- 面包屑导航 -->
        <breadcrumb-top :breadcrumbConfig="dataList" isBack="1"></breadcrumb-top>
        <!-- 面包屑导航 -->
        <div class="content c-top">
            <breadcrumb-search :breadcrumbSearch="searchList"></breadcrumb-search>
            <div>
                <el-form :inline="true" :model="searchForm" ref="searchForm" size="small">
                    <el-form-item label="标签名称" prop="name">
                        <el-input style="width: 232px" v-model="searchForm.name" placeholder="请输入标签名称" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="标签类目" prop="tagId">
                        <el-select style="width: 232px" v-model="searchForm.tagId" placeholder="请选择标签类目" filterable
                            clearable>
                            <el-option v-for="item in tagIds" :key="item.dictId" :label="item.dictName"
                                :value="item.dictId">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="状态" prop="status">
                        <el-select style="width: 232px" v-model="searchForm.status" placeholder="请选择状态" filterable
                            clearable>
                            <el-option label="开启" value="1"></el-option>
                            <el-option label="关闭" value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="创建时间" prop="createdTimeStart">
                        <el-date-picker v-model="value1" style="width: 232px" type="daterange" range-separator="至"
                            start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd HH:mm:ss" :default-time="['00:00:00', '23:59:59']">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item class="form-btn">
                        <el-button type="primary" @click="fetchData('search')">查询</el-button>
                        <el-button type="primary" plain @click="fetchData('reset')">重置</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="content">
            <div class="title">
                <h3>列表数据</h3>
                <div>
                    <el-button type="primary" :loading="exporting" @click="options('add')" size="small"
                        icon="el-icon-plus">新增标签</el-button>
                </div>
            </div>
            <div id="base-list">
                <lb-table v-horizontal-scroll="'always'" :column="columns" :data="list" pagination :total="page.totalNum"
                    layout="total, sizes, prev, pager, next, jumper" :page-sizes="[5, 10, 20, 30, 50]"
                    :current-page.sync="page.pageNo" :page-size="page.pageSize" @selection-change="onMultipleSelection"
                    @size-change="handleSizeChange" @p-current-change="handleCurrentChange">
                </lb-table>
            </div>
        </div>
        <el-dialog title="温馨提示" :visible.sync="isD" width="518px" :append-to-body="true" top="calc(50vh - 100px)">
            <template>
                <div class="info" style="text-align: left">
                    <i class="el-icon-warning" style="color: orange; font-size: 20px"></i>
                    是否确认删除，删除后数据不可恢复！
                </div>
                <div style="display: flex; justify-content: end; margin-top: 24px">
                    <div class="info-q" @click="isD = false">取消</div>
                    <div class="info-s" @click="deleteD">确定</div>
                </div>
            </template>
        </el-dialog>
        <el-dialog :title="optionsTag" :append-to-body="true" :close-on-click-modal="false" :visible.sync="dialogTags"
            width="518px">
            <el-form ref="form" label-width="80px" class="info-form" style="margin-top: 22px" :rules="rules" :model="form">
                <el-form-item label="标签名称" prop="name">
                    <el-input placeholder="请输入标签名称" v-model="form.name" style="width: 100%" maxlength="6"
                        show-word-limit></el-input>
                </el-form-item>


                <el-form-item label="标签类目" prop="category">
                    <el-select style="width: 100%" v-model="form.category" placeholder="请选择标签类目" filterable clearable>
                        <el-option v-for="item in tagIds" :key="item.dictId" :label="item.dictName" :value="item.dictId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="状态" prop="status">
                    <el-radio v-model="form.status" label="1">开启</el-radio>
                    <el-radio v-model="form.status" label="2">关闭</el-radio>
                </el-form-item>
            </el-form>

            <div style="display: flex; justify-content: end; margin-top: 24px">
                <div class="info-q" @click="dialogTags = false">取消</div>
                <div class="info-s" @click="submitT">确定</div>
            </div>
        </el-dialog>
        <el-dialog title="商品数据" :append-to-body="true" :close-on-click-modal="false" :visible.sync="dialogGoods"
            width="50%">
            <div style="max-height: 500px; overflow-y: auto">
                <el-table :data="goodsList" ref="multipleTable" border :header-cell-style="{
                    'text-align': 'left',
                    background: '#F8F8F8',
                    color: '#333333',
                }">
                    <el-table-column prop="goodsName" label="商品信息" width="220px">
                        <template slot-scope="scope">
                            <div style="display: flex">
                                <img :src="scope.row.image" style="width: 72px; height: 56px; margin-right: 12px" alt="" />
                                <div style="
                    font-size: 14px;
                    min-height: 56px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                  ">
                                    <p style="color: #333333">{{ scope.row.name }}</p>
                                    <p style="color: #999999">
                                        商品编号：{{ scope.row.code }}
                                    </p>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="商品类型">
                        <template slot-scope="scope">
                            {{ scope.row.goodsTypeLabel }}
                        </template>
                    </el-table-column>
                    <el-table-column label="价格">
                        <template slot-scope="scope">
                            {{ Number(scope.row.price).toFixed(2) }}
                        </template>
                    </el-table-column>
                    <el-table-column label="状态">
                        <template slot-scope="scope">
                            <div style="display: flex">
                                <div :class="scope.row.status == 1 ? 'start' : 'end'"></div>
                                <div v-if="scope.row.status == 1">上架</div>
                                <div v-else>下架</div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="绑定标签时间" width="180px">
                        <template slot-scope="scope">
                            {{ scope.row.createdTime }}
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="60px">
                        <template slot-scope="scope">
                            <div style="color: red" @click="deleteG(scope.row)">删除</div>
                        </template>
                    </el-table-column>
                </el-table>
                <div style="
            display: flex;
            justify-content: end;
            align-items: center;
            height: 42px;
          ">
                    <el-pagination @size-change="handleSizeChange1" @current-change="handleCurrentChange1"
                        :current-page="pageNo" :page-sizes="[5, 10, 20, 30]" :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper" :total="totalNum">
                    </el-pagination>
                </div>
            </div>

            <div style="display: flex; justify-content: end; margin-top: 24px">
                <!-- <div class="info-q" @click="dialogGoods = false">取消</div> -->
                <div class="info-s" @click="dialogGoods = false">返回</div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
import breadcrumbSearch from '../../../components/breadcrumbSearch.vue'
import LbTable from '../../../components/lb-table/lb-table'
export default {
    components: {
        breadcrumbTop,
        breadcrumbSearch,
        LbTable,
    },
    data() {
        return {
            tagIds: [],
            radio: '1',
            optionsTag: '新增标签',
            dialogGoods: false,
            form: {
                id: '',
                name: '',
                category: '',
                status: '',
            },
            rules: {
                name: [
                    { required: true, message: '请输入标签名称', trigger: 'blur' },
                ],
                category: [
                    { required: true, message: '请选择标签类目', trigger: 'change' },
                ],
                status: [
                    { required: true, message: '请选择状态', trigger: 'change' },
                ],
            },
            goodsList: [

            ],
            dialogTags: false,
            isS: false,
            dataList: {
                list: [
                    { title: '商品管理', path: '', type: '0' },
                    { title: '筛选管理', path: '/shopManagement/screenManagement', type: '1' }
                ]
            },
            searchList: {
                list: [
                    { title: '筛选标签', path: '', type: '0' },
                    { title: '数据筛选', path: '', type: '1' }
                ]
            },
            list: [],
            searchForm: {
                tagName: '',
                status: '',
                createTimeStart: "",
                createTimeEnd: '',
                pageNo: 1,
                pageSize: 10
            },
            value1: [],
            value2: [],
            brandList: [],
            columns: [
                { label: '标签名称', prop: 'name', minWidth: '120' },
                {
                    label: '商品数', prop: 'goodsNum', minWidth: '100',
                    render: (h, scope) => {
                        return (
                            <div>
                                <span style='color:#2D46EE;cursor:pointer' onClick={() => { this.optionG(scope.row.id) }}>{scope.row.goodsNum}</span>
                            </div >
                        )
                    }
                },
                { label: '标签类目', prop: 'parentTagName', minWidth: '120' },
                // { label: '排序', prop: 'sort', minWidth: '130' },
                {
                    label: '状态', prop: 'statusLabel', minWidth: '130',
                    render: (h, scope) => {

                        return (
                            <div>
                                <el-switch
                                    onChange={() => { this.isChange(scope.row) }}
                                    v-model={scope.row.statusL}
                                    active-color="#2D46EE"
                                    inactive-color="#EBEEFA">
                                </el-switch>
                            </div>
                        )
                    }
                },
                { label: '创建时间', prop: 'createdTime', minWidth: '100' },
                {
                    label: '操作',
                    minWidth: '100',
                    fixed: 'right',
                    render: (h, scope) => {
                        return (
                            <div>
                                <span style='color:#2D46EE;cursor:pointer;margin-right:10px' onClick={() => { this.options('edit', scope.row) }}>编辑</span>
                                <span style='color:#2D46EE;cursor:pointer' onClick={() => { this.deleteT(scope.row.id) }}>删除</span>
                            </div >
                        )
                    }
                }],
            page: { pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
            page1: { list: [], pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
            goodsSearch: {
                tagId: '',
                pageNo: 1,
                pageSize: 10,
            },
            exporting: false,
            sName: '启用',
            isStatus: '',
            tagId: null,
            isD: false,
            dId: '',
            pageSize: 10,
            pageNo: 1,
            totalNum: 0,
        }
    },
    created() {
        this.getPageList()
        this.getCategoryList()
    },
    beforeRouteEnter(to, from, next) {
        if (from.name == 'addTag') {
            next(vm => {
                vm.getPageList();
            });
        } else {
            next(vm => {
                vm.getPageList();
            });
        }
    },
    methods: {
        handleSizeChange1(e) {
            this.pageSize = e;
            this.pageNo = 1;
            this.getGoods()
        },
        handleCurrentChange1(e) {
            this.pageNo = e;
            this.getGoods()
        },
        deleteG(row) {
            this.$confirm('是否确认删除？删除后不可恢复数据！', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let data = {
                    id: this.tagId,
                    goodsId: row.id,
                    goodsType: row.goodsType
                }
                this.axios.post('/tagPool/show/deleteGoods', data)
                    .then(res => {
                        console.log(res)
                        this.pageNo = 1;
                        this.getGoods()
                        this.getPageList()
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                    })

            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        isChange(row) {
            let status = 1
            if (row.status == 1) {
                status = 2
            } else {
                status = 1
            }
            let data = {
                id: row.id,
                status: status
            }
            this.axios.post('/tagPool/filter/onOff', data)
                .then(res => {
                    if (res.code == 0) {
                        this.$message.success('操作成功')
                        this.getPageList()

                    }

                })
        },
        deleteD() {
            let data = {
                id: this.dId
            }
            this.axios.post('/tagPool/filter/delete', data)
                .then(res => {
                    if (res.code == 0) {
                        this.$message.success('删除成功')
                        this.isD = false
                        this.getPageList()

                    }

                })
        },
        submitT() {
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    this.axios.post('/tagPool/filter/addEdit', this.form)
                        .then(res => {
                            if (res.code == 0) {
                                if (this.title == '新增标签') {
                                    this.$message.success('添加成功')
                                } else {
                                    this.$message.success('编辑成功')
                                }
                                this.dialogTags = false
                                this.getPageList()
                            }

                        })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        getCategoryList() {
            this.axios.post('/tagPool/filter/categoryList', {})
                .then(res => {
                    // let arr = []
                    // arr = Object.keys(res.data).map(val => ({
                    //     key: val,
                    //     val: res.data[val]
                    // }))
                    // console.log(arr)
                    this.tagIds = res.data
                })
        },
        optionG(id) {
            this.dialogGoods = true
            this.tagId = id
            this.pageNo=1
            this.getGoods()
        },
        getGoods() {
            let data = {
                id: this.tagId,
                pageNo: this.pageNo,
                pageSize: this.pageSize
            }
            this.axios.post('/tagPool/show/goodsList', data)
                .then(res => {
                    if (res.code == 0) {
                        this.goodsList = res.data.list
                        this.totalNum = res.data.totalNum
                    }

                })
        },
        options(type, row) {
            if (type == 'add') {
                this.optionsTag = '新增标签'
                if (this.$refs.form) {
                    this.$refs.form.resetFields()
                }
                this.form.id = ''
                this.form.name = ''
                this.form.status = ''
                this.form.category = ''
            } else {
                this.optionsTag = '编辑标签'
                if (this.$refs.form) {
                    this.$refs.form.resetFields()
                }
                this.form.id = row.id
                this.form.name = row.name
                this.form.status = String(row.status)
                this.form.category = String(row.pid)
            }
            this.dialogTags = true
        },
        deleteT(id) {
            this.isD = true
            this.dId = id
            // let msg = '是否确认删除该商品？'
            // this.$confirm(msg, '温馨信息', {
            //     title: '温馨信息',
            //     confirmButtonText: '确定',
            //     cancelButtonText: '取消',
            //     type: 'warning'
            // }).then(() => {
            //     this.axios.post('/tags/deleteTagGood', { id: id })
            //         .then(res => {
            //             console.log(res)
            //             if (res.code == 0) {
            //                 this.$message.success('删除成功')
            //                 this.getShopList()
            //                 this.getPageList()
            //             }
            //         })
            // }).catch(() => {
            //     this.$message({
            //         type: 'info',
            //         message: '已取消'
            //     })
            // })
        },
        add(val) {
            this.$router.push({
                name: 'addTag',
                query: {
                    id: val
                }
            })
        },
        getShopList() {
            this.goodsSearch.pageNo = this.page1.pageNo
            this.goodsSearch.pageSize = this.page1.pageSize
            this.axios.post('/tags/getGoodsPageByTag', this.goodsSearch)
                .then(res => {
                    console.log(res)
                    this.goodsList = res.data.list;
                    this.page1.totalNum = res.data.totalNum;

                })
        },
        look(id) {
            this.dialogGoods = true
            this.goodsSearch.tagId = id
            this.getShopList()
        },
        isStart(val) {
            this.isS = true
            this.sName = val.statusL
            this.tagId = val.id
            if (val.statusL == '启用') {
                this.isStatus = true
            } else {
                this.isStatus = false
            }

        },
        upStatus() {
            let data = {
                id: this.tagId,
                status: this.isStatus,
            }
            this.axios.post('/tags/updateStatus', data)
                .then(res => {
                    console.log(res)
                    if (res.code == 0) {
                        this.$message.success('操作成功')
                        this.isS = false
                        this.getPageList()
                    }

                })
        },
        exportFn() {
            this.exporting = true
            if (this.value1 && this.value1.length > 0) {
                this.searchForm.joinTimeStart = this.value1[0];
                this.searchForm.joinTimeEnd = this.value1[1];
            } else {
                this.searchForm.joinTimeStart = ''
                this.searchForm.joinTimeEnd = ''
            }
            if (this.value2) {
                this.searchForm.lastActiveTimeStart = this.value2[0];
                this.searchForm.lastActiveTimeEnd = this.value2[1];
            } else {
                this.searchForm.lastActiveTimeStart = ''
                this.searchForm.lastActiveTimeEnd = ''
            }
            this.axios.post('/users/exportList', this.searchForm)
                .then(res => {
                    console.log(res)
                    this.exporting = false;
                    if (res.code === 0) {
                        this.downloadlink(res.data)
                    }
                })
        },
        fetchData(type) {
            this.page.pageNo = 1;
            if (type == 'reset') {
                this.$refs['searchForm'].resetFields()
                this.value1 = []
                this.searchForm.createTimeStart = ''
                this.searchForm.createTimeEnd = ''
            }
            if (this.value1 && this.value1.length > 0) {
                this.searchForm.createTimeStart = this.value1[0];
                this.searchForm.createTimeEnd = this.value1[1];
            } else {
                this.searchForm.createTimeStart = ''
                this.searchForm.createTimeEnd = ''
            }
            this.getPageList()
        },
        getPageList() {
            if (this.value1 && this.value1.length > 0) {
                this.searchForm.createTimeStart = this.value1[0];
                this.searchForm.createTimeEnd = this.value1[1];
            } else {
                this.searchForm.createTimeStart = ''
                this.searchForm.createTimeEnd = ''
            }
            this.searchForm.pageNo = this.page.pageNo;
            this.searchForm.pageSize = this.page.pageSize;
            this.axios.post('/tagPool/filter/pageList', this.searchForm)
                .then(res => {
                    console.log(res)
                    res.data.list.forEach(item => {
                        if (item.status == 1) {
                            item.statusL = true
                        } else {
                            item.statusL = false
                        }
                    })
                    this.list = res.data.list;
                    // let obj = {
                    //     statusLabel: '禁用'
                    // }
                    // this.list.push(obj)
                    this.page.totalNum = res.data.totalNum;
                })
        },
        onMultipleSelection(e) { },
        handleSizeChange(e) {
            this.page.pageSize = e;
            this.page.pageNo = 1;
            this.getPageList()
        },
        handleCurrentChange(e) {
            this.page.pageNo = e;
            this.getPageList()
        },
        // handleSizeChange1(e) {
        //     this.page1.pageSize = e;
        //     this.page1.pageNo = 1;
        //     this.getShopList()
        // },
        // handleCurrentChange1(e) {
        //     this.page1.pageNo = e;
        //     this.getShopList()
        // },
        todetail(row) {
            this.$router.push({
                name: 'userDetail',
                query: {
                    id: row.id
                }
            })
        }
    }
}
</script>
  
<style scoped lang="scss">
.info {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 0px;
    color: #303033;
    opacity: 1;
    text-align: left;
}

.start {
    width: 10px;
    height: 10px;
    background: #13ce4b;
    border-radius: 50%;
    opacity: 1;
    margin-top: 8px;
    margin-right: 5px;
}

.end {
    width: 10px;
    height: 10px;
    background: #f63c56;
    border-radius: 50%;
    opacity: 1;
    margin-top: 8px;
    margin-right: 5px;
}

/deep/ .el-dialog {
    // display: flex;
    // flex-direction: column;
    // margin: 0 !important;
    // position: absolute;
    // top: 50%;
    // left: 50%;
    // transform: translate(-50%, -50%);
    // max-height: calc(100% - 30px);
    // max-width: calc(100% - 30px);

    .el-dialog__body {
        padding: 30px 25px;
        padding-top: 10px !important;
        // height: 800px;
        flex: 1;
        overflow: auto;
    }
}

.info-q {
    width: 124px;
    height: 40px;
    line-height: 40px;
    background: #ffffff;
    border: 1px solid #909099;
    opacity: 1;
    border-radius: 3px;
    text-align: center;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #909099;
    margin-right: 18px;
    cursor: pointer;
}

.info-s {
    width: 126px;
    height: 40px;
    line-height: 40px;
    background: #2d46ee;
    opacity: 1;
    border-radius: 3px;
    text-align: center;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    cursor: pointer;
}

::v-deep .el-input--prefix .el-input__inner {
    padding-left: 37px;
}

.title {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

#base-list {
    margin-top: 20px;
}

:deep(#base-list .lb-table .el-table .el-table__body .el-table__row .el-table__cell:last-child .cell div) {
    display: inline-block;

    a {
        margin: 0 5px;
    }
}

.search-form {
    // margin-top: 20px;
    display: flex;
    flex-wrap: wrap;

    .el-form-item {
        /deep/ .el-form-item__label {
            width: 100px;
            text-align: right;
            vertical-align: middle;
            float: left;
            box-sizing: border-box;
        }

        /deep/ .el-form-item__content {
            display: block;
            margin-left: 100px;

            .el-cascader,
            .el-select {
                width: 100%;
            }
        }
    }

    .form-btn {
        /deep/ .el-form-item__content {
            line-height: 36px;
            margin-left: 50px;
        }
    }
}

/deep/ .el-table__row {
    .el-table__cell {
        padding: 12px 0;
    }
}

/deep/ .el-table {
    color: #303033;
}
</style>
  
  